import React from "react"
import { Link } from "react-router-dom"
import { Input, Button, Table, Space, Select } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import axios, { axiosTable } from '../../tool/axios'
import BreadCrumb from '../../component/BreadCrumb'

const { Column } = Table
const { Option } = Select

interface State {
    data: object[],
    pregStatus: object[],
    loading: boolean,
    pagination: {
        current: number,
        pageSize: number,
        total: number,
    },
    fetchOtherParams: {
        preg_status: string | null,
        remind_desc_down_title: string
    },
    formParams: {
        item_type: string | null
    },
    offShelfVisible: boolean,
    addVisible: false
}

export default class HealthRemindList extends React.Component {
    state: State = {
        data: [],
        loading: false,
        pregStatus: [],
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0
        },
        fetchOtherParams: {
            preg_status: null,
            remind_desc_down_title: ''
        },
        formParams: {
            item_type: null
        },
        offShelfVisible: false,
        addVisible: false
    }

    componentDidMount() {
        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
        this.fetchStatus()
    }

    offShelf() {
        this.setState({ offShelfVisible: true })
    }

    handleSelectChange(value: string) {
        let { fetchOtherParams } = this.state;
        fetchOtherParams.preg_status = value

        this.setState({
            fetchOtherParams
        })
    }

    handleInputChange(e: any) {
        let { fetchOtherParams } = this.state
        fetchOtherParams.remind_desc_down_title = e.target.value

        this.setState({ fetchOtherParams })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current
        pagination.pageSize = antPagination.pageSize

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/manage_center/preg_status_remind/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            const { pagination } = this.state
            pagination.total = response.total
            pagination.pageSize = response.size
            pagination.current = response.current

            this.setState({
                pagination,
                data: response.records
            })
        })
    }

    resetForm() {
        let { fetchOtherParams } = this.state
        fetchOtherParams.remind_desc_down_title = ''
        fetchOtherParams.preg_status = null

        this.setState({ fetchOtherParams })
        this.selectState('')
    }

    fetchStatus() {
        axiosTable.get('/manage_center/preg_status/list', {

        }).then((response: any) => {
            this.setState({
                pregStatus: response
            })
        })
    }

    selectState(type: string) {
        let { pagination, fetchOtherParams } = this.state;

        if (type != 'current') {
            pagination.current = 1;
        }

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    delItem(id: string) {
        axios.post('/manage_center/preg_status_remind/delete', { id: id }).then((response: any) => {
            this.selectState('current')
        })
    }

    render() {
        let { remind_desc_down_title } = this.state.fetchOtherParams

        return (<div className="common-page">
            {/* 管理中心 -> 妈妈状态管理 -> 门店管理 */}
            <BreadCrumb position={['管理中心', '健康提醒管理']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <Select style={{ marginRight: 8, marginBottom: 12, width: '150px' }} allowClear={true} value={this.state.fetchOtherParams.preg_status as string} onChange={this.handleSelectChange.bind(this)} placeholder="妈妈状态">
                        {this.state.pregStatus.map((item: any) => {
                            return <Option value={item.preg_status} key={item.id}>{item.status_name}</Option>
                        })}
                    </Select>
                    <Input style={{ marginRight: 8, marginBottom: 12, width: '180px' }} placeholder="标题" value={remind_desc_down_title === null ? '' : remind_desc_down_title} onChange={this.handleInputChange.bind(this)} />
                </Space>

                <div style={{ marginTop: 10 }}>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={this.selectState.bind(this, '')} >查询</Button>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={this.resetForm.bind(this)} icon={<RedoOutlined />}>重置</Button>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary"><Link to={"/health_remind_add"}>添加</Link></Button>
                </div>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} pagination={this.state.pagination} rowKey="id" onChange={this.handleTableChange.bind(this)}>
                    <Column title="妈妈状态" dataIndex="preg_status" key="preg_status" render={(value: number): string => value === 1 ? '正在备孕' : (value === 2 ? '已经怀孕' : '已有宝宝')} />
                    <Column title="状态阶段" dataIndex="child_preg_status" key="child_preg_status" render={(value: number): string => value === 1 ? '月经期' : (value === 2 ? '卵泡期' : (value == 3 ? '排卵期' : '--'))} />
                    <Column title="天数" dataIndex="which_day" key="which_day" />
                    <Column title="健康提醒标题" dataIndex="remind_desc_down_title" key="remind_desc_down_title" />

                    <Column
                        title="操作"
                        key="action"
                        render={(record: any) => (
                            <Space size="middle">
                                <Link to={"/health_remind_edit/" + record.id}><Button type="primary">查看</Button></Link>
                                <Button type="primary" danger onClick={this.delItem.bind(this, record.id)}>删除</Button>
                            </Space>
                        )}
                    />
                </Table>
            </div>
        </div>)
    }
}